export default "__VITE_ASSET__Ca2qPLIE__"